import React from 'react';

export default function SpecializedSolutions() {
    return (
        <section className="bg-white pt-8 sm:pt-12 pb-8 sm:pb-12 relative overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 relative z-10">
                {/* Header */}
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-10 sm:mb-16 gap-6 sm:gap-8">
                    <h2 className="text-black text-4xl sm:text-5xl md:text-4xl font-bold max-w-2xl leading-tight tracking-tight">
                        Where ideas become results
                    </h2>

                    <div className="flex flex-col items-start lg:items-end gap-6 text-left lg:text-right w-full lg:w-auto">
                        <p className="text-gray-500 text-base sm:text-lg leading-relaxed max-w-md font-medium">
                            We design focused solutions that drive growth, increase impact, and move your business forward.
                        </p>


                    </div>
                </div>

                {/* Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {/* Card 1: Hosting */}
                    <div className="group cursor-pointer">
                        <div className="w-full h-56 sm:h-64 bg-gray-100 rounded-[2rem] mb-6 relative overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1000"
                                alt="Managed Hosting & Infrastructure"
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                            />
                        </div>
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 leading-snug">
                            Managed Hosting &<br />Cloud Infrastructure
                        </h3>
                        <p className="text-gray-500 text-sm sm:text-base leading-relaxed pr-4">
                            Enterprise-grade hosting designed for speed, stability, and effortless scaling as your business grows.
                        </p>
                    </div>

                    {/* Card 2: Development */}
                    <div className="group cursor-pointer">
                        <div className="w-full h-56 sm:h-64 bg-gray-100 rounded-[2rem] mb-6 relative overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&q=80&w=1000"
                                alt="Full-Stack Web Development"
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                            />
                        </div>
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 leading-snug">
                            Full-Stack Development &<br />Easy Deployment
                        </h3>
                        <p className="text-gray-500 text-sm sm:text-base leading-relaxed pr-4">
                            End-to-end engineering and automated CI/CD pipelines for fast, secure, and reliable product launches.
                        </p>
                    </div>

                    {/* Card 3: Support */}
                    <div className="group cursor-pointer">
                        <div className="w-full h-56 sm:h-64 bg-gray-100 rounded-[2rem] mb-6 relative overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1623682783900-fea916dcba74?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                alt="Technical Troubleshooting"
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                            />
                        </div>
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 leading-snug">
                            Rapid Troubleshooting &<br />Dedicated Support
                        </h3>
                        <p className="text-gray-500 text-sm sm:text-base leading-relaxed pr-4">
                            We solve complex technical debt, performance bottlenecks, and critical bugs with precision and speed.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
